import React, { useEffect, useState } from "react";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Alert,
  Modal,
  Card,
} from "react-bootstrap";
import ProfileInfoForm from "./ProfileInfoForm";
import InputField from "../common/InputField/InputField";
import { UserProfileVerificationDetails, verifyUserProfile } from "@/api/bid";
// import validateForm from "./Validations";
import validateForm2 from "./ValidateProfileVerification";
import { validateForm } from "@/utils/formValidator";
import "./Bid.css";
import IdologyQuestions from "../IdologyVerification/IdologyQuestions";
import { BsCheckCircleFill } from "react-icons/bs";
import {
  getUserProfileVerificationDetails,
  sendEmailLink,
} from "@/api/myProfile";
import { trackEvent } from "@/utils/analytics";

import { useDispatch, useSelector } from "react-redux";
import { MdModeEditOutline } from "react-icons/md";
import verification from "./../../../public/assets/images/verification.png";
import secure from "./../../../public/assets/images/secure.png";
import edit from "./../../../public/assets/images/edit.png";
import register from "./../../../public/assets/images/register.png";
import ProfileInfo from "./ProfileInfo";
import { toast } from "react-toastify";
import { trackApiCall, trackButtonClick } from "@/utils/analytics";

// import Loader from "../common/loader/Loader";
// import ProfileInfoSecond from "./ProfileInfoSecond";
const AccordianFormProfile = ({
  onNavigate,
  isOfferPage,
  cmsData,
  onFirstAccordionComplete,
}) => {
  const offerPage = isOfferPage || false;
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    dateOfBirth: "",
    ssnNo: "",
    emailId: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [showIdolodyQuestions, setShowIdolodyQuestions] = useState(false);
  const [question, setQuestions] = useState([]);
  const [ideologyError, setIdeologyError] = useState();
  const [dob, setDob] = useState(""); // React state for date of birth
  const [ssn, setSsn] = useState(""); // React state for SSN
  const [remainingAttemptCount, setRemainingAttemptCount] = useState(null);
  const [errors, setErrors] = useState({});
  const [maskedDuplicateEmailID, setMaskedDuplicateEmailID] = useState("");
  const [isIdologyVerified, setIsIdologyVerified] = useState(true);

  const [collapseAccordian, setCollapseAccordian] = useState(1);
  const profileInfo = useSelector((state) => state.user.profileInfo);

  const [submittedAccordions, setSubmittedAccordions] = useState([]);
  const [emailSend, setEmailSend] = useState(false);
  const [showSendLink, setShowSendLink] = useState(false);

  const formatDate = (dateString) => {
    if (dateString.includes("-")) {
      const [year, month, day] = dateString.split("-");
      return `${month}/${day}/${year}`;
    } else if (dateString.includes("/")) {
      const [month, day, year] = dateString.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
    return dateString;
  };

  const isProfileCompleted = () => {
    if (
      profileInfo?.data === null ||
      profileInfo?.data?.userDetails?.address?.address1 === null ||
      profileInfo?.data?.userDetails?.address?.address1?.length === 0 ||
      profileInfo?.data?.userDetails?.address?.city === null ||
      profileInfo?.data?.userDetails?.address?.city?.length === 0
    ) {
      // handleone();
      return true;
    } else {
      return false;
    }
  };

  const [accordianOpen, setaccordianOpen] = useState(1);

  let curr = new Date();
  curr.setDate(curr.getDate());
  let date = curr.toISOString().substring(0, 10);

  const [formErrors, setFormErrors] = useState({});
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleInputChange = (event, setFormData, setErrors, validateForm) => {
    const { id, value } = event.target;

    // console.log("id ->", id);

    // Update the form data state
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));

    // Perform validation using validateForm utility
    const validationErrors = validateForm({ [id]: value }, [id]);

    // Update errors state dynamically
    setErrors((prevErrors) => ({
      ...prevErrors,
      [id]: validationErrors[id] || "", // Add error if invalid, or clear if valid
    }));
  };

  const IdologyFormValues = {
    userBasicDetails: {
      firstName: formData?.firstName,
      lastName: formData?.lastName,
      emailId: formData?.emailId,
    },
    dob: formatDate(dob), // Use React state for DOB
    ssn: ssn, // Use React state for SSN
  };

  const handleDobChange = (e) => {
    const { name, value } = e.target;
    setDob(value);
    const validationErrors = validateForm({ [name]: value }, [name]);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: validationErrors[name] || "",
    }));
  };

  const idologySuccess = () => {
    setIdeologyError("");
    setIsIdologyVerified(true);
    onNavigate(2);
  };

  useEffect(() => {
    const fetchUserAttempts = async () => {
      try {
        const response = await getUserProfileVerificationDetails();
        setRemainingAttemptCount(
          response?.data?.userIdologyDetailsDto?.remainingAttemptCount
        );
        const showLink =
          response?.data?.userIdologyDetailsDto?.resetCountExceeded &&
          response?.data?.userIdologyDetailsDto?.scanAvailable &&
          !response?.data?.userIdologyDetailsDto?.mailSent;
        setShowSendLink(showLink);
      } catch (error) {
        console.error("Error fetching remaining attempt count:", error);
      }
    };

    fetchUserAttempts();
  }, []);

  const handleone = () => {
    setaccordianOpen(2);
    setSubmittedAccordions((prev) => [...prev, 1]);
    setCollapseAccordian(1);

    if (onFirstAccordionComplete) {
      onFirstAccordionComplete();
    }
    trackButtonClick({
      eventName: "idology_verify_click",
      eventCategory: "Bid/Offer wizard",
      eventSource: "on profile verify success",
    });

    UserProfileVerificationDetails()
      .then((response) => {
        // console.log(
        //   "Profile verification details:",
        //   response?.data?.userBasicDetails
        // );
        const { firstName, lastName, ssn, dob, emailId } =
          response?.data?.userBasicDetails;
        // Set the verification data to state if needed
        setFormData((prevData) => ({
          ...prevData,
          firstName: firstName || "",
          lastName: lastName || "",
          dateOfBirth: dob || "",
          ssnNo: ssn || "",
          emailId: emailId || "",
        }));
      })
      .catch((error) => {
        console.error("Error fetching profile verification:", error);
      });

    // scrollSmooth();
  };

  const handletwo = () => {
    setaccordianOpen(3);
    // scrollSmooth();
  };

  const renderVerificationHeader = () => {
    // return(
    // <Row>
    //       <Col md={12}>
    //         <Card className=" profile-faq-card  mb-3 p-2">
    //           {/* <Card.Header className="profile-faq-card-header">
    //             <h3 className="text-left">Profile</h3>
    //           </Card.Header> */}
    //           <Card.Body className="profile-faq-card-body">
    //             {/* <p>{cmsData?.profile_Info_Title}</p> */}
    //             <div className="">
    //               <p className="profileHeaderText">Verification</p>
    //               <p className="profileBodyText">For more information on the verification process, please see our
    //                 <a
    //                   href="/portal/support"
    //                   target="_blank"
    //                   className=" linkkk_bid link-offset-2"
    //                 >
    //                   {" "} FAQs.
    //                 </a>
    //               </p>
    //             </div>
    //             <hr className="profile-faq-divider" />
    //             <Row>
    //               <Col md={6}>
    //                 <Row className="align-items-center">
    //                   <Col xs={2}>
    //                     <img src={secure}
    //                                width={50}
    //                               height={50}/>
    //                   </Col>
    //                   <Col xs={10} className="profile-faq-flip-card-inner">
    //                     <div className="profile-faq-flip-card-front">
    //                       <h5 className="profileHeaderText">What do you do with the information I enter?</h5>
    //                     </div>
    //                     <div className="profile-faq-flip-card-back">
    //                       <p className="mt-3 profileBodyText">The information is used to verify your identity. We do not store your Social Security number or date of birth in our database, and this information is deleted as soon as your identity is verified.</p>
    //                     </div>
    //                   </Col>
    //                 </Row>
    //               </Col>
    //            <Col md={6}>
    //                 <Row className="align-items-center">
    //                   <Col xs={2}>
    //                     <img src={verification}
    //                                width={50}
    //                               height={50}/>
    //                   </Col>
    //                   <Col xs={10} className="profile-faq-flip-card">
    //                      <div className="profile-faq-flip-card-front">
    //                       <h5 className="profileHeaderText">Will I have to go through this process every time I log in to Hubzu?</h5>
    //                     </div>
    //                     <div className="profile-faq-flip-card-back">
    //                       <p className="mt-3 profileBodyText">No. This is a one-time verification process. Once your information is verified, you won't be asked to repeat it.</p>
    //                     </div>
    //                   </Col>
    //                 </Row>
    //               </Col>
    //             </Row>
    //           </Card.Body>
    //         </Card>
    //       </Col>
    //     </Row>
    // );
  };

  const renderProfileHeader = () => {
    // return(
    //    <Row>
    //       <Col md={12}>
    //         <Card className=" profile-faq-card  mb-3 p-2">
    //           {/* <Card.Header className="profile-faq-card-header">
    //             <h3 className="text-left">Profile</h3>
    //           </Card.Header> */}
    //           <Card.Body className="profile-faq-card-body">
    //             {/* <p>{cmsData?.profile_Info_Title}</p> */}
    //             <div className="">
    //               <p className="profileHeaderText">Profile</p>
    //               <p className="profileBodyText">{cmsData?.profile_Info_Title}
    //                 <a
    //                   href="/portal/support"
    //                   target="_blank"
    //                   className=" linkkk_bid link-offset-2"
    //                 >
    //                   {" "} FAQs.
    //                 </a>
    //               </p>
    //             </div>
    //             <hr className="profile-faq-divider" />
    //             <Row>
    //               <Col md={6}>
    //                 <Row className="align-items-center">
    //                   <Col xs={2}>
    //                     <img src={register}
    //                                width={50}
    //                               height={50}/>
    //                   </Col>
    //                   <Col xs={10} className="profile-faq-flip-card-inner">
    //                     <div className="profile-faq-flip-card-front">
    //                       <h5 className="profileHeaderText">{cmsData?.profile_Info_Reg_que}</h5>
    //                     </div>
    //                     <div className="profile-faq-flip-card-back">
    //                       <p className="mt-3 profileBodyText">{cmsData?.profile_Info_Reg_ans}</p>
    //                     </div>
    //                   </Col>
    //                 </Row>
    //               </Col>
    //            <Col md={6}>
    //                 <Row className="align-items-center">
    //                   <Col xs={2}>
    //                    <img src={edit}
    //                                width={50}
    //                               height={50}/>
    //                   </Col>
    //                   <Col xs={10} className="profile-faq-flip-card">
    //                      <div className="profile-faq-flip-card-front">
    //                       <h5 className="profileHeaderText">{cmsData?.profile_Info_User_que}</h5>
    //                     </div>
    //                     <div className="profile-faq-flip-card-back">
    //                       <p className="mt-3 profileBodyText">{cmsData?.profile_Info_User_ans}</p>
    //                     </div>
    //                   </Col>
    //                 </Row>
    //               </Col>
    //             </Row>
    //           </Card.Body>
    //         </Card>
    //       </Col>
    //     </Row>
    // )
  };

  const handleBlur = (e) => {
    const { id, value } = e.target;
    const { isValid, errors } = validateForm2({ [id]: value });

    setErrors((prev) => ({
      ...prev,
      [id]: errors[id],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIdeologyError("");
    try {
      const data = {
        firstName: IdologyFormValues?.userBasicDetails?.firstName,
        lastName: IdologyFormValues?.userBasicDetails?.lastName,
        dateOfBirth: IdologyFormValues?.dob,
        ssnNo: IdologyFormValues?.ssn,
      };

      const { isValid, errors } = validateForm2(data);

      if (!isValid) {
        setErrors(errors);
        return;
      } else {
        setErrors({});
        const payload = {
          dob: formatDate(formData.dateOfBirth),
          ssn: formData.ssnNo,
          userBasicDetails: {
            firstName: formData.firstName,
            lastName: formData.lastName,
            emailId: formData.emailId,
          },
        };
      }

      trackButtonClick({
        eventName: "idology_submit",
        eventCategory: "Bid/Offer wizard",
        eventSource: "on verify click",
      });

      try {
        setIsLoading(true);
        const response = await verifyUserProfile(IdologyFormValues);
        const verificationResult = response?.data;
        if (verificationResult?.status === "SUCCESS") {
          setIsLoading(false);

          if (verificationResult?.data?.questions?.length > 0) {
            setShowIdolodyQuestions(true);

            setQuestions(verificationResult?.data?.questions);
          } else {
            trackApiCall({
              eventName: "bid_idology_verification_success",
              eventCategory: "Bid/Offer wizard",
              eventSource: "on Idology verify success",
              eventParams: { idology_verification: "successful" },
            });

               if (profileInfo?.userDetails?.phoneNumberVerified === true) {
                 trackEvent({
                   name: "ready_to_bid",
                   category: "New-Bid Wizard",
                   eventSource: "on Ideology Verification",
                   eventLabel: "",
                 });
               }
            // if(offerPage){
            //   toast.success("Your profile is verified successfully.");

            // }
            setIdeologyError("");
            // setIsIdologyVerified(true);
            onNavigate(2);
          }
        } else {
          setIsLoading(false);
          setIdeologyError(verificationResult?.errorMessage);

          trackApiCall({
            eventName: "confirm_idology_failure",
            eventCategory: "My Shopper",
            eventSource: "Global alerts idology from my profile",
            eventParams: {
              error_type:
                verificationResult?.errorMessage ===
                "errorIdologyAttemptsExceeded"
                  ? "attempt_exceeded"
                  : verificationResult?.errorMessage ===
                      "errorIdologyIdFailure" &&
                    verificationResult?.data?.remainingAttemptCount === 0
                  ? "attempt_exceeded"
                  : verificationResult?.errorMessage === "errorIdologyDuplicate"
                  ? "idology_duplicate"
                  : "idology_failure",
            },
          });

          setRemainingAttemptCount(
            verificationResult?.data?.remainingAttemptCount
          );
          const showLink =
            response?.data?.resetCountExceeded &&
            response?.data?.scanAvailable &&
            !response?.data?.mailSent;
          setShowSendLink(showLink);
          if (verificationResult?.errorMessage === "errorIdologyDuplicate") {
            // console.log(verificationResult?.data?.maskedDuplicateEmailID);
            setMaskedDuplicateEmailID(
              verificationResult?.data?.maskedDuplicateEmailID
            );
          }
          // toast.error("User profile verification failed. Please try again.");
        }
      } catch (error) {
        // toast.error("An error occurred while verifying the user profile.");
        console.error(
          "Error fetching user profile verification details:",
          error
        );
      }
    } catch (error) {
      console.error("Error verifying user profile:", error);
      setFormErrors({
        verification:
          "An error occurred while verifying your information. Please try again.",
      });
    }
    //   console.log("Form submitted:", formData);
    //   // handletwo();
    //   alert("Form submitted successfully!");
    // }
  };
  // console.log(showSendLink, "sd");

  const sendLinkToEmail = async () => {
    try {
      const data = await sendEmailLink();
      if (data?.status === "SUCCESS") {
        setEmailSend(true);
      } else {
        setEmailSend(false);
        // console.log(data, "data error");
      }
    } catch (error) {
      // console.log(error);
      setEmailSend(false);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Dynamically validate the field using validateForm
    const validationErrors = validateForm({ [name]: value }, [name]);

    // Update form data
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    // Update error state based on validation
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: validationErrors[name] || null, // Add error if invalid or clear if valid
    }));
  };

  const formDetails = [
    {
      label: "First Name",
      type: "text",
      placeholder: "First Name",
      required: true,
      editLink: false,
      formValueLabel: "firstName",
    },
    {
      label: "Last Name",
      type: "text",
      placeholder: "Last Name",
      required: true,
      editLink: false,
      formValueLabel: "lastName",
    },
    {
      label: "D.O.B",
      type: "date",
      placeholder: "date of birth",
      required: true,
      editLink: false,
      formValueLabel: "dateOfBirth",
    },
    {
      label: "SSN No.",
      type: "number",
      placeholder: "Last 4 Digits of SSN",
      required: true,
      editLink: false,
      formValueLabel: "ssnNo",
    },
  ];

  const handleClose = () => {
    setShowIdolodyQuestions(false);
    setDob("");
    setSsn("");
  };

  const renderIdeolodyScreen = () => {
    return (
      <div className="">
        <div className="">
          {offerPage && showIdolodyQuestions ? (
            <div className="mx-3">
              <IdologyQuestions
                dob={formatDate(dob)}
                ssn={ssn}
                questions={question}
                setQuestions={setQuestions}
                handleClose={handleClose}
                isFromAlerts={false}
                idoSuccess={idologySuccess}
                isFromBid={true}
                setIdeologyError={setIdeologyError}
                parentComponent="MyBid"
              />
            </div>
          ) : (
            <Container className="mt-12">
              <>
                <>
                  <div className="row">
                    <br />
                    <div className="col-6">
                      <label htmlFor="firstName" className="profileLabel">
                        First Name
                      </label>

                      <input
                        className="form-control profileLabel"
                        type="text"
                        id="firstName"
                        required
                        value={formData.firstName || ""}
                        onChange={(event) =>
                          handleInputChange(
                            event,
                            setFormData,
                            setErrors,
                            validateForm
                          )
                        }
                        onBlur={handleBlur}
                      />
                      {errors.firstName && (
                        <span className="errorTxt">{errors.firstName}</span>
                      )}
                    </div>
                    <br />
                    <div className="col-6">
                      <label htmlFor="lastName" className="profileLabel">
                        Last Name
                      </label>

                      <input
                        className="form-control profileLabel"
                        type="text"
                        id="lastName"
                        required
                        value={formData.lastName || ""}
                        onChange={(event) =>
                          handleInputChange(
                            event,
                            setFormData,
                            setErrors,
                            validateForm
                          )
                        }
                        onBlur={handleBlur}
                      />
                      {errors.lastName && (
                        <span className="errorTxt">{errors.lastName}</span>
                      )}

                      <br />
                    </div>
                    <div className="col-6">
                      <label htmlFor="dateOfBirth" className="profileLabel">
                        Date of Birth
                      </label>

                      <input
                        type="date"
                        id="dateOfBirth"
                        className="form-control profileLabel"
                        required
                        value={dob || ""}
                        name="dob"
                        max={date}
                        onChange={(e) => handleDobChange(e)}
                        onBlur={handleBlur}
                      />
                      {errors.dateOfBirth && (
                        <span className="errorTxt">{errors.dateOfBirth}</span>
                      )}

                      <br />
                    </div>
                    <div className="col-6">
                      <label htmlFor="ssnNo" className="profileLabel">
                        Enter Last Four digit of SSN
                      </label>

                      <input
                        className="form-control profileLabel"
                        type="text"
                        id="ssnNo"
                        required
                        value={ssn || ""}
                        onChange={(e) => setSsn(e.target.value)}
                        maxLength={4}
                        placeholder="Last 4 Digits of SSN"
                        onBlur={handleBlur}
                      />
                      {errors.ssnNo && (
                        <span className="errorTxt">{errors.ssnNo}</span>
                      )}
                    </div>
                  </div>
                  <br />

                  {ideologyError === "errorIdologyIdFailure" && (
                    <div className="pb5 pt10">
                      <h6 className="errorTxt fs-14">Authentication failed.</h6>
                      <p className="errorTxt fs-11">
                        Please enter your first name, last name, last 4 digits
                        of your Social Security Number and date of birth as they
                        appear on government-issued documents.
                      </p>
                      <p className="errorTxt fs-11">
                        You have {remainingAttemptCount} more attempt to log in
                        before your account is locked. Please call Customer Care
                        at (855) 882-1314 with questions or concerns.
                      </p>
                    </div>
                  )}
                  {ideologyError === "errorIdologyAttemptsExceeded" && (
                    <div className="pb10 pt10">
                      <p className="errorTxt fs-11">
                        Your account has been locked because you have failed the
                        authentication process three times. Please contact
                        Customer Care at (855) 882-1314 or
                        customercare@hubzu.com for further assistance.
                      </p>
                    </div>
                  )}
                  {ideologyError === "errorIdologyDuplicate" && (
                    <div className="pb10 pt10">
                      <h6 className="errorTxt fs-14">Authentication failed.</h6>
                      <p className="errorTxt fs-11">
                        Our records show, you already have an account on Hubzu
                        with {maskedDuplicateEmailID}. If you want to change the
                        email id, please login to Hubzu.com and change the email
                        Id. Please contact customer care at (855) 882-1314 or
                        customercare@hubzu.com for any assistance.
                      </p>
                    </div>
                  )}
                  {ideologyError === "errorIdologySystemError" && (
                    <div className="pb10 pt10">
                      <p className="errorTxt fs-11">
                        We’re currently experiencing technical difficulties with
                        the verification system. Please try again later or
                        contact Customer Care at (855) 882-1314.
                      </p>
                    </div>
                  )}

                  <Button
                    className={"veriftyCTA-offer"}
                    aria-controls="example-collapse-text"
                    variant="primary"
                    onClick={handleSubmit}
                  >
                    {isLoading ? "Verifing..." : "Verify"}
                  </Button>

                  <br></br>
                </>
              </>
            </Container>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      {/* {isLoading && <Loader />} */}
      {/* <ProfileInfo data={cmsData} /> */}

      <ProfileInfo data={cmsData} accordianOpen={accordianOpen} />
      <div className="accordion" id="accordionFlushExample">
        <div className="accordion-item buyer-agent-accordion">
          {/* <h2 className="accordion-header">

            <button
              className={`accordion-button ${accordianOpen === 1 ? "" : "collapsed"
                }`}
              type="button"
              onClick={() => setaccordianOpen(1)}
              aria-expanded={accordianOpen === 1}
            >
            {submittedAccordions?.includes(1)  ? (
                  <BsCheckCircleFill className="icon_bid me-2" size={30} />
                ) : (
                  <BsCheckCircleFill className="text-dark me-2" size={30} />
                )}
              <p className="bid_font_cif pt10"> Profile Information </p>
            </button>
          </h2> */}
          <h2 className="accordion-header">
            <button
              className={`accordion-button no-caret ${
                accordianOpen === 1 ? "" : "collapsed"
              }`}
              type="button"
              onClick={() => setaccordianOpen(1)}
              aria-expanded={accordianOpen === 1}
            >
              <div className="d-flex align-items-center justify-content-between w-100">
                <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
                  {submittedAccordions?.includes(1) ? (
                    <BsCheckCircleFill className="icon_bid me-2" size={30} />
                  ) : (
                    <BsCheckCircleFill className="text-dark me-2" size={30} />
                  )}
                  <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
                    <span className="bid_accordian">Profile Information</span>
                  </div>
                </div>

                {/* Edit button shown only if accordion has been submitted */}

                <button
                  aria-label="Edit"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setaccordianOpen(1);
                    trackButtonClick({
                      eventName: "bid_accordion_edit",
                      eventCategory: "Profile Accordion Bid/Offers",
                      eventLabel: "accordion edit clicked",
                      eventSource: "on edit icon click",
                    });
                  }}
                  style={{
                    background: "none",
                    border: "none",
                    padding: 0,
                    cursor: "pointer",
                  }}
                >
                  <MdModeEditOutline size={16} />
                </button>
                {/* <Button

                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setaccordianOpen(1);
                  }}
                  style={{ "pointer-events": "all" }} >
                  <MdModeEditOutline size={16} color="#000"
                  />
                </Button> */}
              </div>
            </button>
          </h2>
          <div
            id="flush-collapseOne"
            className={`accordion-collapse collapse ${
              accordianOpen === 1 ? "show" : ""
            }`}
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <Row>
                <Col sm={12}>
                  <div className="profile-completion-section">
                    <h4 className="profileTitleText">
                      Please complete Your Profile
                    </h4>

                    <p className="profileText">
                      Please take a few minutes to complete your profile with
                      accurate information. We need this information to help us
                      verify you, which in turn helps with a better bidding
                      experience on Hubzu for all our users. By letting only
                      genuine verified bidders place bids, we reduce the chances
                      of failed bids or transactions.
                    </p>
                    <hr />
                  </div>
                </Col>
                <ProfileInfoForm
                  handleone={handleone}
                  setSubmittedAccordions={setSubmittedAccordions}
                  setaccordianOpen={setaccordianOpen}
                  offerPage={offerPage}
                />
                {/* <ProfileInfoSecond /> */}
              </Row>
            </div>
            {/* <Button onClick={handleone}>next</Button> */}
          </div>
        </div>
        <div className="accordion-item border mb-2 rounded">
          <h2 className="accordion-header">
            <button
              className={`accordion-button ${
                accordianOpen === 2 ? "" : "collapsed"
              }`}
              type="button"
              onClick={() => setaccordianOpen(2)}
              aria-expanded={accordianOpen === 2}
            >
              <div className="d-flex align-items-center justify-content-between w-100">
                <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
                  <BsCheckCircleFill className="text-dark me-2" size={30} />

                  <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
                    <span className="bid_accordian">Profile Verification</span>
                  </div>
                </div>

                {/* Edit button shown only if accordion has been submitted */}

                {/* <button onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setaccordianOpen(2);
                  }}
                  style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}>
                  <MdModeEditOutline size={16} />
                </button> */}
                {/* <Button

                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setaccordianOpen(1);
                  }}
                  style={{ "pointer-events": "all" }} >
                  <MdModeEditOutline size={16} color="#000"
                  />
                </Button> */}
              </div>
            </button>
          </h2>
          <div
            id="flush-collapseTwo"
            className={`accordion-collapse collapse ${
              accordianOpen === 2 ? "show" : ""
            }`}
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <Row>
                {ideologyError === "errorIdologyAttemptsExceeded" ||
                remainingAttemptCount === 0 ? (
                  <div className="pb10 pt10">
                    {emailSend ? (
                      <>
                        <p className="fs-12">
                          We've sent a message to your registered email address.
                          Please follow the instructions to complete your
                          verification by uploading a valid government issued
                          ID.
                        </p>
                      </>
                    ) : (
                      <>
                        <p className="fs-12">
                          Your account has been locked because you have failed
                          the authentication process three times. Please contact
                          Customer Care at (855) 882-1314 or
                          customercare@hubzu.com for further assistance.
                          {showSendLink && (
                            <>
                              <br />
                              Alternatively, Hubzu may be able to manually
                              verify your identity using your government-issued
                              identification. Please click below to receive
                              additional information and instructions about this
                              process.
                            </>
                          )}
                        </p>
                        {showSendLink && (
                          <p className="text-center fs-12 robo-light">
                            <button
                              className="send-link btn btn-primary"
                              onClick={sendLinkToEmail}
                            >
                              Scan Link{" "}
                            </button>
                          </p>
                        )}
                      </>
                    )}
                  </div>
                ) : (
                  <Col>
                    <h4 className="profileTitleText">
                      Please verify your details
                    </h4>

                    <p className="profileText">
                      Please take a moment to verify your identity by entering
                      your first name, last name, date of birth and the last 4
                      digits of your Social Security Number. Verifying your
                      information keeps the Hubzu® marketplace safe and
                      accessible for everyone.
                    </p>
                    <p className="profileText">
                      This is a one-time verification of your information.
                    </p>
                    <hr />

                    <Container>
                      <Row>
                        <Col md={12}>
                          {/* {isLoading && <Loader />} */}

                          {renderIdeolodyScreen()}
                        </Col>
                      </Row>
                    </Container>
                  </Col>
                )}
              </Row>
            </div>
            {/* <Button onClick={handletwo}>verify</Button> */}
          </div>
        </div>
      </div>
      {!offerPage && showIdolodyQuestions && (
        <Modal show={showIdolodyQuestions} onHide={handleClose}>
          <Modal.Body>
            <IdologyQuestions
              dob={formatDate(dob)}
              ssn={ssn}
              questions={question}
              setQuestions={setQuestions}
              handleClose={handleClose}
              isFromAlerts={false}
              idoSuccess={idologySuccess}
              parentComponent="MyBid"
            />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default AccordianFormProfile;

// {

// }
